import React, { useEffect, useState, useRef } from "react"

import PropTypes from "prop-types"

import "./index.less"
import { Input, Button, List, message } from "antd"
import Loader from "../../../../../components/Loader"

const { TextArea } = Input

export const DrawerSegmentImportableResult = ({
  steps,
  mode,
  id_segment,
  changeSteps,
  getTemplateSegmentCollaborators,
  uploadTemplateSegmentCollaborators,
  combineGroupResultsWithSuccessfullEmployeeResults,
  importUpload,
  clearImportUpload,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [successCollaborators, setSuccessCollaborators] = useState([])
  const [failedCollaborators, setFailedCollaborators] = useState([])
  const finalizeImportCollaborators = () => {
    combineGroupResultsWithSuccessfullEmployeeResults(successCollaborators)
    clearImportUpload()
    setSuccessCollaborators([])
    setFailedCollaborators([])
    changeSteps(0)
  }
  const inputRef = useRef(null)
  const reuploadCollaborators = async () => {
    inputRef.current.click()
  }
  useEffect(() => {
    if (!importUpload) {
      setIsLoading(true)
    } else {
      setIsLoading(false)
      setFailedCollaborators(importUpload.responseErrors)
      setSuccessCollaborators(importUpload.successEmployees)
    }
  }, [importUpload])

  const fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    if (mode === "edit" && id_segment) {
      fd.append("id_segment", id_segment)
      inputRef.current.value = ""
    }
    uploadTemplateSegmentCollaborators(fd)
  }
  const renderFooter = () => {
    return (
      <div className="footer-drawer">
        <Button onClick={reuploadCollaborators} style={{ marginRight: 8 }}>
          Reintentar
        </Button>
        <Button type="primary" onClick={finalizeImportCollaborators}>
          Finalizar
        </Button>
      </div>
    )
  }
  const errorListRender = (errors) => {
    return errors.map((error, index) => {
      return <div key={index}>{error}</div>
    })
  }
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Button
            type="link"
            style={{ width: "max-content", padding: 0 }}
            className="drawer-segment-importable-result-back-button"
            onClick={() => {
              clearImportUpload()
              changeSteps(0)
            }}>
            &lt; Regresar
          </Button>
          <br />
          <span className="drawer-segment-container-label">
            Importación de colaboradores a un segmento
          </span>
          <p>
            Revisa si se ha producido algún error en la importación de la
            información. De ser el caso, realiza las correcciones necesarias y
            vuelve a importar el archivo.
          </p>
          <span className="drawer-segment-container-label">
            Resumen de importación
          </span>
          <br />
          <div>
            <span className="drawer-segment-importable-result-success">
              {successCollaborators.length == 1 ? (
                <>
                  <b>{successCollaborators.length}</b> colaborador importado
                </>
              ) : (
                <>
                  <b>{successCollaborators.length}</b> colaboradores importados
                </>
              )}
            </span>
            &nbsp;
            {failedCollaborators.length > 0 && (
              <span className="drawer-segment-importable-result-failed">
                {failedCollaborators.length == 1 ? (
                  <>
                    <b>{failedCollaborators.length}</b> colaborador sin importar
                  </>
                ) : (
                  <>
                    <b>{failedCollaborators.length}</b> colaboradores sin
                    importar
                  </>
                )}
              </span>
            )}
          </div>
          <br />
          <br />
          <div className="drawer-segment-importable-result-table-container">
            <div className="drawer-segment-importable-result-table-header">
              <span className="drawer-segment-importable-result-table-header-cell">
                Colaborador
              </span>
              <span className="drawer-segment-importable-result-table-header-cell">
                DNI
              </span>
              <span className="drawer-segment-importable-result-table-header-cell">
                Error
              </span>
              <span className="drawer-segment-importable-result-table-header-cell">
                Fila
              </span>
            </div>
            <List
              locale={{ emptyText: "No hay errores para mostrar." }}
              bordered
              dataSource={failedCollaborators}
              style={{ backgroundColor: "#fff" }}
              renderItem={(item) => (
                <List.Item>
                  <div className="drawer-segment-importable-result-table-row">
                    <span className="drawer-segment-importable-result-table-row-cell">
                      {item.fullName}
                    </span>
                    <span className="drawer-segment-importable-result-table-row-cell">
                      {item.document}
                    </span>
                    <span className="drawer-segment-importable-result-table-row-cell">
                      {errorListRender(item.errors)}
                    </span>
                    <span className="drawer-segment-importable-result-table-row-cell">
                      {item.row}
                    </span>
                  </div>
                </List.Item>
              )}
            />
          </div>

          <br />
          <br />
        </>
      )}
      <input
        style={{ display: "none" }}
        type="file"
        id="import"
        onChange={fileSelectedHandler}
        ref={inputRef}
      />
      {renderFooter()}
    </>
  )
}
export default DrawerSegmentImportableResult
